import React, { useState, useContext } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import languageContext from "../context/language/languageContext";
import PhoneInput from "react-phone-input-2";

const DoctorSignup = () => {
  const navigate = useNavigate();
  const { phone, setPhone } = useContext(languageContext);

  const [formData, setFormData] = useState({
    name: "",
    speciality: "",
    address: "",
    license: "",
  });

  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

const validatePhone = (number) => {
  console.log(number)
  const cleaned = number.replace(/\D/g, "");
  return cleaned.length >= 12 && cleaned.length <= 15;
};
  const handleSignup = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!validatePhone(phone)) {
      setError("Please enter a valid 10-digit mobile number.");
      return;
    }

    try {
      setLoader(true);

      const response = await axios.post(
        "https://www.careplus.gopillz.com/doctor_signup_send_otp",
        {
          phone,
          name: formData.name,
          speciality: formData.speciality,
          address: formData.address,
          license_number: formData.license,
        },
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 201 || response.status === 202) {
        setSuccess("OTP sent successfully.");
        setTimeout(() => {
          navigate("/otp", { state: { from: "signup" } });
        }, 800);
      } else {
        setError("Unexpected server response.");
      }
    } catch (err) {
      setError(
        err.response?.data?.message || "Failed to send OTP. Please try again."
      );
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 via-white to-blue-200 px-4">

      <div className="w-full max-w-lg bg-white/90 backdrop-blur-xl shadow-2xl rounded-3xl p-8 border border-blue-100">

        {/* Title */}
        <h2 className="text-3xl font-bold text-center text-blue-700 mb-2">
          Doctor Registration
        </h2>
        <p className="text-center text-gray-500 text-sm mb-6">
          Register as Hospital Doctor or Independent Practitioner
        </p>

        <form onSubmit={handleSignup} className="space-y-5">

          {/* Full Name */}
          <InputField
            label="Full Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Dr. John Doe"
          />

          {/* Speciality */}
         {/* Speciality Dropdown */}
<div>
  <label className="label">Medical Speciality</label>

  <select
    required
    name="speciality"
    value={formData.speciality}
    onChange={handleChange}
    className="input"
  >
    <option value="" disabled hidden>
      Select Speciality
    </option>

    {/* Core Medical Specialties */}
    <optgroup label="General & Internal Medicine">
      <option value="General Physician">General Physician</option>
      <option value="Internal Medicine">Internal Medicine</option>
      <option value="Family Medicine">Family Medicine</option>
    </optgroup>

    <optgroup label="Cardiac Sciences">
      <option value="Cardiology">Cardiology</option>
      <option value="Interventional Cardiology">Interventional Cardiology</option>
      <option value="Cardiothoracic Surgery">Cardiothoracic Surgery</option>
    </optgroup>

    <optgroup label="Neuro Sciences">
      <option value="Neurology">Neurology</option>
      <option value="Neurosurgery">Neurosurgery</option>
    </optgroup>

    <optgroup label="Orthopedics & Spine">
      <option value="Orthopedics">Orthopedics</option>
      <option value="Spine Surgery">Spine Surgery</option>
      <option value="Joint Replacement">Joint Replacement</option>
    </optgroup>

    <optgroup label="Women’s Health">
      <option value="Obstetrics & Gynecology">Obstetrics & Gynecology</option>
      <option value="Reproductive Medicine">Reproductive Medicine</option>
      <option value="Gynecologic Oncology">Gynecologic Oncology</option>
    </optgroup>

    <optgroup label="Child Health">
      <option value="Pediatrics">Pediatrics</option>
      <option value="Neonatology">Neonatology</option>
      <option value="Pediatric Cardiology">Pediatric Cardiology</option>
    </optgroup>

    <optgroup label="Surgical Specialties">
      <option value="General Surgery">General Surgery</option>
      <option value="Plastic Surgery">Plastic Surgery</option>
      <option value="Urology">Urology</option>
      <option value="Vascular Surgery">Vascular Surgery</option>
    </optgroup>

    <optgroup label="Cancer Care">
      <option value="Medical Oncology">Medical Oncology</option>
      <option value="Surgical Oncology">Surgical Oncology</option>
      <option value="Radiation Oncology">Radiation Oncology</option>
    </optgroup>

    <optgroup label="Respiratory & Critical Care">
      <option value="Pulmonology">Pulmonology</option>
      <option value="Critical Care Medicine">Critical Care Medicine</option>
      <option value="Emergency Medicine">Emergency Medicine</option>
    </optgroup>

    <optgroup label="Digestive & Liver">
      <option value="Gastroenterology">Gastroenterology</option>
      <option value="Hepatology">Hepatology</option>
    </optgroup>

    <optgroup label="Hormone & Metabolic">
      <option value="Endocrinology">Endocrinology</option>
      <option value="Diabetology">Diabetology</option>
    </optgroup>

    <optgroup label="Kidney Care">
      <option value="Nephrology">Nephrology</option>
    </optgroup>

    <optgroup label="Skin & Cosmetology">
      <option value="Dermatology">Dermatology</option>
      <option value="Cosmetology">Cosmetology</option>
    </optgroup>

    <optgroup label="Mental Health">
      <option value="Psychiatry">Psychiatry</option>
      <option value="Clinical Psychology">Clinical Psychology</option>
    </optgroup>

    <optgroup label="ENT & Eye">
      <option value="ENT (Otolaryngology)">ENT (Otolaryngology)</option>
      <option value="Ophthalmology">Ophthalmology</option>
    </optgroup>

    <optgroup label="Other Specialties">
      <option value="Anesthesiology">Anesthesiology</option>
      <option value="Radiology">Radiology</option>
      <option value="Pathology">Pathology</option>
      <option value="Rheumatology">Rheumatology</option>
      <option value="Infectious Diseases">Infectious Diseases</option>
      <option value="Palliative Care">Palliative Care</option>
    </optgroup>

    <option value="Other">Other / Super Speciality</option>
  </select>

  {!formData.speciality && (
    <p className="text-red-500 text-sm mt-1">
      Please select a speciality.
    </p>
  )}
</div>


          {/* Address */}
          <div>
            <label className="label">Hospital / Clinic Address</label>
            <textarea
              name="address"
              value={formData.address}
              onChange={handleChange}
              required
              rows="3"
              placeholder="Enter complete address"
              className="input resize-none"
            />
          </div>

          {/* License */}
          <InputField
            label="Medical License Number"
            name="license"
            value={formData.license}
            onChange={handleChange}
            placeholder="Enter license number"
          />

          {/* Phone */}
          <div>
            <label className="label">Mobile Number</label>
            <PhoneInput
   // Default country, change to 'in' or any ISO 3166-1 alpha-2 code if needed
  enableSearch={true}
  disableCountryCode={false} // Show country code in UI
  disableDropdown={false}   // Enable country selection
  value={phone}
  onChange={setPhone}
  inputClass="!w-full !px-4 !py-2 !text-sm !border !border-gray-300 !rounded-lg !bg-gray-50"
  buttonClass="!border-gray-300"
  containerClass="!w-full"
/>
          </div>

          {/* Error / Success */}
          {error && (
            <div className="text-red-500 text-sm font-medium text-center">
              {error}
            </div>
          )}

          {success && (
            <div className="text-green-600 text-sm font-medium text-center">
              {success}
            </div>
          )}

          {/* Button */}
          <button
            type="submit"
            disabled={loader}
            className={`w-full py-3 rounded-xl text-white font-semibold text-sm transition-all duration-300 ${
              loader
                ? "bg-blue-400 cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700 hover:shadow-lg"
            }`}
          >
            {loader ? "Sending OTP..." : "Register & Get OTP"}
          </button>
        </form>

        {/* Login Link */}
        <div className="mt-6 text-center text-sm text-gray-600">
          Already registered?{" "}
          <Link
            to="/login"
            className="text-blue-600 font-semibold hover:underline"
          >
            Login Here
          </Link>
        </div>

      </div>
    </div>
  );
};

const InputField = ({ label, name, value, onChange, placeholder }) => (
  <div>
    <label className="label">{label}</label>
    <input
      type="text"
      name={name}
      value={value}
      onChange={onChange}
      required
      placeholder={placeholder}
      className="input"
    />
  </div>
);

export default DoctorSignup;
